// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card__PricingPanel-module--eOhMB {
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
    height: 100%;
    padding: var(--space-lg);
    border-radius: var(--home-radius-3xl);
    background: var(--color-surface-inverse);
    color: var(--color-neutral-100);
}

.head__PricingPanel-module--gUs94 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-sm);
}

.heading__PricingPanel-module--nwLdv {
    margin: 0;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
    color: var(--color-text-on-brand);
}

.figure__PricingPanel-module--WT4FV {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xs);
    margin-top: auto;
}

.price__PricingPanel-module--tJog5 {
    margin: 0;
    font-size: clamp(48px, 8vw, 88px);
    font-weight: 800;
    letter-spacing: -0.03em;
    line-height: 0.9;
    color: var(--home-color-orange);
}

.priceNote__PricingPanel-module--zPAVW {
    margin: 0;
    font-size: 17px;
    color: var(--color-neutral-300);
}

.footer__PricingPanel-module--Jrtum {
    display: flex;
    flex-direction: column;
    gap: var(--space-sm);
    padding-top: var(--space-md);
    border-top: 1px solid var(--color-neutral-700);
}

.footer__PricingPanel-module--Jrtum > :first-child {
    align-self: flex-start;
}

.hint__PricingPanel-module--xC1pR {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
    color: var(--color-neutral-300);
}

.hint__PricingPanel-module--xC1pR a {
    color: var(--home-color-orange);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/PricingPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,wBAAwB;IACxB,qCAAqC;IACrC,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":[".card {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n    height: 100%;\n    padding: var(--space-lg);\n    border-radius: var(--home-radius-3xl);\n    background: var(--color-surface-inverse);\n    color: var(--color-neutral-100);\n}\n\n.head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--space-sm);\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n    color: var(--color-text-on-brand);\n}\n\n.figure {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2xs);\n    margin-top: auto;\n}\n\n.price {\n    margin: 0;\n    font-size: clamp(48px, 8vw, 88px);\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    line-height: 0.9;\n    color: var(--home-color-orange);\n}\n\n.priceNote {\n    margin: 0;\n    font-size: 17px;\n    color: var(--color-neutral-300);\n}\n\n.footer {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n    padding-top: var(--space-md);\n    border-top: 1px solid var(--color-neutral-700);\n}\n\n.footer > :first-child {\n    align-self: flex-start;\n}\n\n.hint {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.55;\n    color: var(--color-neutral-300);\n}\n\n.hint a {\n    color: var(--home-color-orange);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card__PricingPanel-module--eOhMB`,
	"head": `head__PricingPanel-module--gUs94`,
	"heading": `heading__PricingPanel-module--nwLdv`,
	"figure": `figure__PricingPanel-module--WT4FV`,
	"price": `price__PricingPanel-module--tJog5`,
	"priceNote": `priceNote__PricingPanel-module--zPAVW`,
	"footer": `footer__PricingPanel-module--Jrtum`,
	"hint": `hint__PricingPanel-module--xC1pR`
};
export default ___CSS_LOADER_EXPORT___;
